import { HTTPVerbs as a, request as c } from "@nextgen-web-framework/core";
const n = "v1", d = {
  "Content-Type": "application/json"
};
`${n}`, a.POST, {
  ...d
};
const l = {
  url: `/comorderas/${n}/order-confirm`,
  params: {},
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, p = {
  url: `/comorderas/${n}/orders/search`,
  params: {},
  method: a.POST,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, h = {
  url: `/comorderas/${n}/reports/orders/search`,
  params: {},
  method: a.POST,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, g = {
  url: `/comorderas/${n}/reports/orders/returns/search`,
  params: {},
  method: a.POST,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, y = {
  url: `/comorderas/${n}/orders/returns/search`,
  params: {},
  method: a.POST,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, T = {
  url: `/comorderas/${n}/orders`,
  params: {},
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, P = {
  url: `/comorderas/${n}/orders`,
  params: {},
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, O = {
  url: `/comorderas/${n}/reasons`,
  params: { query: "EligibleForSelfService=true", reasonType: "Cancel", size: "100" },
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, $ = {
  url: `/comorderas/${n}/reasons`,
  params: { query: "EligibleForSelfService=true", reasonType: "Return", size: "100" },
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0
}, f = {
  url: `/comorderas/${n}/order-cancel`,
  params: {},
  method: a.PUT,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, S = {
  url: `/comorderas/${n}/return-cancel`,
  params: {},
  method: a.PUT,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, I = {
  url: `/comorderas/${n}/orders/replacements`,
  params: {},
  method: a.POST,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, b = {
  url: `/comorderas/${n}/orders/replacements`,
  params: {},
  method: a.PUT,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, R = {
  url: `/comorderas/${n}/orders/returns`,
  params: {},
  method: a.POST,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, v = {
  url: `/comorderas/${n}/orders/returns`,
  params: {},
  method: a.PUT,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, E = {
  url: `/comorderas/${n}/next-numbers`,
  params: { count: "1", counterType: "GenerateReturnOrderId" },
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0
}, k = {
  url: `/comorderas/${n}/next-numbers`,
  params: { count: "1", counterType: "GenerateExchangeOrderId" },
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0
}, D = {
  url: `/comorderas/${n}/replacement-eligible-items`,
  params: {},
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, G = {
  url: `/comorderas/${n}/return-eligible-items`,
  params: {},
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, U = {
  url: `/comorderas/${n}/orders/returns`,
  params: {},
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, N = {
  url: `/comorderas/${n}/returns`,
  params: {},
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, A = {
  url: `/comorderas/${n}/replacement`,
  params: {},
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, j = {
  url: `/comorderas/${n}/images/upload`,
  params: {},
  method: a.POST,
  retries: 0,
  timeout: 3e4
}, q = {
  url: `/comorderas/${n}/images/retrieve`,
  params: {},
  method: a.POST,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, w = {
  url: `/comorderas/${n}/images/delete`,
  params: {},
  method: a.POST,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, J = {
  url: `/comorderas/${n}/orders/returns`,
  params: {},
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, B = {
  url: `/comorderas/${n}/orders/`,
  params: {},
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 3e4
}, M = {
  url: `/comorderas/${n}/orders/track-delivery`,
  params: {},
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 3e4
}, C = {
  url: `/comorderas/${n}/orders/anonymous-track-delivery`,
  params: {},
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 3e4
}, u = {
  url: `/comorderas/${n}`,
  params: {},
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, H = {
  url: `/comorderas/${n}/orders/invoices`,
  params: {},
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, L = {
  url: `/comorderas/${n}`,
  params: {},
  method: a.POST,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, x = {
  url: `/comorderas/${n}/packages/printStatus`,
  params: {},
  method: a.POST,
  headers: {
    ...d
  },
  retries: 0,
  timeout: 12e3
}, Y = {
  url: `/comorderas/${n}/packages/getPrintStatus`,
  params: {},
  method: a.POST,
  headers: {
    ...d
  },
  retries: 0
}, z = {
  url: `/comorderas/${n}/returns/item-conditions`,
  params: {},
  method: a.GET,
  headers: {
    ...d
  },
  retries: 0
}, _ = {
  Detailed: "DETAILED",
  Summary: "SUMMARY",
  AdminDetailed: "ADMIN_DETAILED",
  AdminSummary: "ADMIN_SUMMARY"
}, V = {
  getOrderByOrderId(r, e) {
    if (!r)
      return Promise.resolve({
        code: "UI-001",
        message: "Please check arguments"
      });
    const t = { ...l, ...e };
    return t.url += `/${r}`, m(t);
  },
  fetchAllOrders({ offset: r, limit: e, ...t }, s) {
    const o = { ...p, ...s };
    return !r.toString() || !e ? Promise.resolve({
      code: "UI-001",
      message: "Please check arguments"
    }) : (o.body = JSON.parse(
      JSON.stringify({
        offset: r,
        limit: e,
        ...t
      })
    ), m(o));
  },
  getOrderHistory({ offset: r, limit: e, ...t }, s) {
    const o = { ...T, ...s };
    return !r.toString() || !e ? Promise.resolve({
      code: "UI-001",
      message: "Please check arguments"
    }) : (o.params = {
      offset: r,
      limit: e,
      projection: "HISTORY",
      ...t
    }, m(o));
  },
  fetchReturnOrders({ offset: r, limit: e, ...t }, s) {
    const o = { ...y, ...s };
    return r && !r.toString() || !e ? Promise.resolve({
      code: "UI-001",
      message: "Please check arguments"
    }) : (o.body = JSON.parse(
      JSON.stringify({
        offset: r,
        limit: e,
        ...t
      })
    ), o.params = {
      projection: "LISTING"
    }, m(o));
  },
  getOrderDetailsByOrderId(r, e, t, s) {
    if (!r)
      return Promise.resolve({
        code: "UI-001",
        message: "Please check arguments"
      });
    const o = { ...P, ...t };
    return o.url += `/${r}`, o.params = {
      projection: e,
      viewReturns: !s && e === _.Detailed
    }, m(o);
  },
  getOrderCancellationReasons(r) {
    const e = { ...O, ...r };
    return m(e);
  },
  getOrderReturnReasons(r, e) {
    const t = { ...$, ...r }, s = t.params, o = new URLSearchParams(s);
    return e && Object.keys(e).length > 0 && (o.append("reasonId", (e == null ? void 0 : e.reasonId) ?? ""), o == null || o.append("projection", (e == null ? void 0 : e.projection) ?? ""), e != null && e.query && (o.delete("query"), o.append("query", (e == null ? void 0 : e.query) ?? "")), e != null && e.reasonType && (o.delete("reasonType"), o.append("reasonType", (e == null ? void 0 : e.reasonType) ?? ""))), t.params = o, m(t);
  },
  getProductCondtions(r) {
    const e = { ...z, ...r };
    return m(e);
  },
  cancelOrderByOrderId(r, e) {
    const t = { ...f, ...e };
    return t.body = r, m(t);
  },
  createReplacementDraftOrder(r, e) {
    const t = { ...I, ...e };
    return t.body = r, m(t);
  },
  createReplacementOrder(r, e) {
    const t = { ...b, ...e };
    return t.body = r, m(t);
  },
  createReturnDraftOrder(r, e) {
    const t = { ...R, ...e };
    return t.body = r, m(t);
  },
  createReturnOrder(r, e) {
    const t = { ...v, ...e };
    return t.body = r, m(t);
  },
  getReturnNumber(r) {
    const e = { ...E, ...r };
    return m(e);
  },
  getReplacementNumber(r) {
    const e = { ...k, ...r };
    return m(e);
  },
  fetchEligibleReturnProducts(r, e) {
    const t = { ...G, ...e };
    return t.url += `/${r}`, m(t);
  },
  fetchEligibleReplacementProducts(r, e) {
    const t = { ...D, ...e };
    return t.url += `/${r}`, m(t);
  },
  getReplacementOrderDataByReplacementNumber(r, e, t) {
    const s = { ...A, ...t };
    return s.url += `/${r}`, s.params = {
      orderId: e
    }, m(s);
  },
  getReturnDetails(r, e, t) {
    const s = { ...U, ...e };
    return s.url += `/${r}`, s.params = {
      projection: "DETAILED",
      ...t && {
        state: t
      }
    }, m(s);
  },
  cancelReturnByReturnId(r, e) {
    const t = { ...S, ...e };
    return t.body = r, m(t);
  },
  returnOrderImagesUpload(r, e) {
    const t = { ...j, ...e };
    return t.body = r, m(t, { skipDefaultContentType: !0 });
  },
  getReturnOrderImages(r, e) {
    const t = { ...q, ...e };
    return t.body = r, m(t);
  },
  deleteReturnOrderImages(r, e) {
    const t = { ...w, ...e };
    return t.body = r, m(t);
  },
  geReturnHistory({ offset: r, limit: e, ...t }, s) {
    const o = { ...J, ...s };
    return !r.toString() || !e ? Promise.resolve({
      code: "UI-001",
      message: "Please check arguments"
    }) : (o.params = {
      offset: r,
      limit: e,
      projection: "HISTORY",
      ...t
    }, m(o));
  },
  getReturnOrderDataByReturnNumber(r, e, t) {
    const s = { ...N, ...t };
    return s.url += `/${r}`, s.params = {
      orderId: e
    }, m(s);
  },
  getLatamDeliveryTracking({ orderId: r, consignmentNumber: e, trackingId: t }, s) {
    const o = { ...B, ...s };
    return o.url = `${o.url}${r}/consignments/${e}/track-delivery`, o.params = {
      trackingId: t
    }, m(o);
  },
  getDeliveryTracking({ offset: r, limit: e, isAnonymous: t, ...s }, o) {
    const i = t ? { ...C, ...o } : { ...M, ...o };
    return !r.toString() || !e ? Promise.resolve({
      code: "UI-001",
      message: "Please check arguments"
    }) : (i.params = {
      offset: r,
      limit: e,
      ...s
    }, m(i));
  },
  getPackageDetailsByOrderId(r, e, t) {
    if (!r)
      return Promise.resolve({
        code: "UI-001",
        message: "Please check arguments"
      });
    const s = { ...u, ...t };
    return s.url += `/orders/${r}/consignments`, s.params = {
      projection: e
    }, m(s);
  },
  getInvoiceDocument(r, e, t) {
    if (!r.toString())
      return Promise.resolve({
        code: "UI-001",
        message: "Please check arguments"
      });
    const s = { ...H, ...t };
    return s.params = {
      uid: r
    }, e && (s.params = { ...s.params, hash: e }), m(s);
  },
  getOrderPackageDetails(r, e, t) {
    if (!r)
      return Promise.resolve({
        code: "UI-001",
        message: "Please check arguments"
      });
    const s = { ...u, ...t };
    return s.url += `/orders/${r}/packages`, s.params = {
      projection: e
    }, m(s);
  },
  managePackageAction(r, e, t, s) {
    const o = { ...L, ...s };
    return o.url += `/orders/${e}/packages/${t}/manage`, o.body = r, m(o);
  },
  getOrdersPrintStatus(r, e) {
    const t = { ...Y, ...e };
    return t.body = r, m(t);
  },
  saveOrdersPrintStatus(r, e) {
    const t = { ...x, ...e };
    return t.body = r, m(t);
  },
  async downloadOrders({ offset: r, limit: e, ...t }, s) {
    const o = { ...h, ...s };
    return !(r != null && r.toString()) || !e ? Promise.resolve({
      code: "UI-001",
      message: "Please check arguments"
    }) : (o.body = JSON.parse(
      JSON.stringify({
        offset: r,
        limit: e,
        ...t
      })
    ), (await m(o)).blob());
  },
  async downloadReturnOrders({ offset: r, limit: e, ...t }, s) {
    const o = { ...g, ...s };
    return !(r != null && r.toString()) || !e ? Promise.resolve({
      code: "UI-001",
      message: "Please check arguments"
    }) : (o.body = JSON.parse(
      JSON.stringify({
        offset: r,
        limit: e,
        ...t
      })
    ), (await m(o)).blob());
  }
};
async function m(r, e) {
  const t = await c(r, e);
  return Promise.resolve(t);
}
export {
  V as M
};
//# sourceMappingURL=postpurchaseApi-d69b5b43.mjs.map
